<template>
    <div class="header-challenge-list">
        <h1 class="header-challenge-list__h1">{{ textH1 }}</h1>
        <p class="header-challenge-list__desc">{{ textDesc }}</p>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            textH1: {
                type: String,
                default: 'Lorem Ipsum'
            },
            textDesc: {
                type: String,
                default: 'Lorem ipsum dolor sit amet.'
            }
        }
    };
</script>

<style scoped src="@/css/components/header-challenge-list.css"></style>